import * as React from 'react';
import { Route, Routes } from 'react-router-dom-v5-compat';

import Error404 from 'af-root/scenes/Error/error404';

import AttachmentsTab from 'af-components/SharedForms/Job/AttachmentsTab';
import BillingCodes from 'af-components/SharedForms/Job/BillingCodes';
import Details from 'af-components/SharedForms/Job/Details';
import JobHazardAssessment from 'af-components/SharedForms/Job/JobHazardAssessment';

import JobEdit from './index';
import { JobEditTabRoutes } from './types';

const JobEditRouter: React.FC = () => {
	return (
		<Routes>
			<Route
				element={<JobEdit />}
			>
				<Route element={<Details />} index />
				<Route element={<Details />} path={JobEditTabRoutes.DETAILS} />
				<Route element={<BillingCodes />} path={JobEditTabRoutes.BILLING_CODES} />
				<Route element={<JobHazardAssessment />} path={JobEditTabRoutes.JOB_HAZARD_ASSESSMENT} />
				<Route element={<AttachmentsTab />} path={JobEditTabRoutes.ATTACHMENTS} />
			</Route>
			<Route element={<Error404 />} path="*" />
		</Routes>
	);
};

export default React.memo(JobEditRouter);
